module.exports = {
      id: "2f07e5657d80339fa19749b1bae2e192roofShape-hip.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#2f07e5657d80339fa19749b1bae2e192roofShape-hip.svg",
      toString: function () {
        return this.url;
      }
    }